



































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import SNavMenu from './SNavMenu.vue';
import SSubmenu from './SSubmenu.vue';

@Component({
  components: {
    SSubmenu,
  },
})
export default class SMenuItem extends Vue {
  @Inject({ from: 'sNavMenu' }) public sNavMenu!: SNavMenu;
  @Prop(Boolean) public burger!: boolean;
  @Prop(String) public route?: string;
  @Prop(String) public namedRoute?: string;
  @Prop(Boolean) public exact?: boolean;
  @Prop(String) public icon?: string;
  @Prop(Boolean) public deep?: boolean;
  @Prop(Boolean) public disabled?: boolean;

  public isSubmenuOpen = false;

  public toggleSubmenuOpen() {
    this.isSubmenuOpen = !this.isSubmenuOpen;
  }

  public hoverSubmenu(value = false) {
    if (this.sNavMenu.side && !this.sNavMenu.reactiveProps.expanded && !this.burger) this.isSubmenuOpen = value;
  }

  get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  get showSubmenuToggleIcon() {
    return (!this.sNavMenu.expandable || this.sNavMenu.reactiveProps.expanded || this.deep) && !!this.$slots.submenu;
  }

  get showSubmenuHoverIcon() {
    return !this.sNavMenu.reactiveProps.expanded && !!this.$slots.submenu;
  }

  get showIcon() {
    return !this.disabled && (this.showSubmenuToggleIcon || this.showSubmenuHoverIcon);
  }

  @Watch('sNavMenu.reactiveProps.expanded')
  public forceCollapse(expanded: boolean) {
    if (!expanded) this.isSubmenuOpen = false;
  }
}
